import { Box, Typography } from '@mui/material';
import React, { FC } from 'react';
import { contactFeatureStyle } from '../../../../shared/lib/theme/styleConstants';
import { ContactFeatureProps } from '../../app/interfaceTypes';

const ContactFeature: FC<ContactFeatureProps> = ({ icon, text }) => {
  return (
    <Box display="flex" alignItems="center" gap={2}>
      <Box sx={contactFeatureStyle}>{icon}</Box>
      <Typography variant="body1">{text}</Typography>
    </Box>
  );
};

export default ContactFeature;
